import { render, staticRenderFns } from "./LeftBarNotificationArrow.vue?vue&type=template&id=3de88fac&scoped=true&"
import script from "./LeftBarNotificationArrow.vue?vue&type=script&lang=ts&"
export * from "./LeftBarNotificationArrow.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBarNotificationArrow.vue?vue&type=style&index=0&id=3de88fac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de88fac",
  null
  
)

export default component.exports